import service from "../api/services/questionService";

export default {
  namespaced: true,
  state: {
    questions: [],
    questionsTypeList: []
  },

  mutations: {

    setQuestions(state, questions) {
      state.questions = questions;
    },
    setQuestionsTypeList(state, questionsTypeList) {
      state.questionsTypeList = questionsTypeList;
    },

  },
  actions: {
    setQuestions(context, data) {
      context.commit("setQuestions", data);
    },
    setQuestionsTypeList(context, data) {
      context.commit("setQuestionsTypeList", data);
    },
    getExternalQuestionsList(context, reqData) {
      return service
        .getExternalQuestionsList(reqData)
        .then((response = {}) => {
          return response.responseData;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    editExternalQuestion(context, reqData) {
      return service
        .editExternalQuestion(reqData)
        .then((response = {}) => {
          return response.responseData;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    publishQuestionsToMasterDb(context, reqData) {
      return service
        .publishQuestionsToMasterDb(reqData)
        .then((response = {}) => {
          return response.responseData;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
  }
};
